import axios from 'axios';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelToken;
let cancelTokenPagination;
let cancelTokenUser;
let cancelTokenMethods;
export const getPaymentsList = (payload) => {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }

  // Если заново запрашиваем листинг, пагинация в Pending не актуальная
  if (cancelTokenPagination) {
    cancelTokenPagination.cancel('Operation canceled');
  }

  const parsedPayload = pickBy(payload);
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get('/payments/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelToken.token,
  });
};

export const getPaymentsListPagination = (payload) => {
  if (cancelTokenPagination) {
    cancelTokenPagination.cancel('Operation canceled');
  }

  cancelTokenPagination = axios.CancelToken.source();
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/list-pagination', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenPagination.token,
  });
};

export const getUserForPayment = (payload) => {
  if (cancelTokenUser) {
    cancelTokenUser.cancel('Operation canceled');
  }

  cancelTokenUser = axios.CancelToken.source();
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/find-user', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenUser.token,
  });
};

export const getPaymentsConfig = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/configuration', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getPaymentExportList = () => axiosInstance.get('/payments/export-list', { params: pickDevParams });

export const getPaymentExportConfig = () => axiosInstance.get('/payments/export-configuration', { params: pickDevParams });

export const downloadPaymentExport = (id) => axiosInstance.get(`/payments/export-download/${id}`, { params: pickDevParams });

export const getPaymentDetails = (id) => axiosInstance.get(`/payments/response/${id}`, { params: pickDevParams });

export const getPaymentSuperDetails = (id) => axiosInstance.get(`/payments/response-superadmin/${id}`, { params: pickDevParams });

export const getPaymentsFraudRisk = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/fraud-risk', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getPaymentsMethods = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/methods', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getPaymentsCurrentMethods = () => {
  if (cancelTokenMethods) {
    cancelTokenMethods.cancel('Operation canceled');
  }

  cancelTokenMethods = axios.CancelToken.source();
  return axiosInstance.get('/payments/current-methods', { params: pickDevParams, cancelToken: cancelTokenMethods.token });
};

export const getPaymentsModes = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/modes', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getPaymentsStatuses = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/payments/statuses', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getSearchUsersList = (query) => axiosInstance.get('/payments/autocomplete-users', { params: { ...pickDevParams, query } });

export const addPayment = (payload) => axiosInstance.post('/payments/add', { ...payload, ...pickDevParams });

export const editPayment = (id, payload) => axiosInstance.post(`/payments/edit/${id}`, { ...payload, ...pickDevParams });

export const completePayment = (id, payload) => axiosInstance.post(`/payments/complete/${id}`, { ...payload, ...pickDevParams });

export const sendFraudReport = (id, payload) => axiosInstance.post(`/payments/fraud-report/${id}`, { ...payload, ...pickDevParams });

export const makePaymentExport = (payload) => axiosInstance.post('/payments/export-make', { ...payload, ...pickDevParams });
export const rejectPayment = (id) => axiosInstance.post(`/payments/reject/${id}`, { ...pickDevParams });
